import { render, staticRenderFns } from "./close-inventory.vue?vue&type=template&id=4e36401c"
import script from "./close-inventory.vue?vue&type=script&lang=js"
export * from "./close-inventory.vue?vue&type=script&lang=js"
import style0 from "./close-inventory.vue?vue&type=style&index=0&id=4e36401c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports